import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../../utils/enum';
import {
  departmentDefaultValue,
  departmentSchema,
} from '../Common/DefaultValuesAndSchema';
import { EditDepartmentForm } from '../Common/EditCategoryForm';
import { GoBackIconButton } from './GoBackIconButton';

export default function EditDepartmentCategoryMobile() {
  const navigate = useNavigate();
  const { departmentId } = useParams();
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...departmentSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...departmentDefaultValue,
    },
    shouldUnregister: false,
  });

  const [putCategoryResult, putCategory] = useAuthAxios({
    method: 'PUT',
    url: `/api/v1/department/${departmentId}`,
  });
  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      description: values.description,
    };
    putCategory({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>관리부서 수정</MobileTitle>
        <Button variant="text" onClick={onSubmit}>
          수정
        </Button>
        <ApiResultModal
          apiResult={putCategoryResult}
          successTitle="수정됐습니다."
          successCode={200}
          onSuccessClose={() => {
            navigate(`/category`);
          }}
          failTitle="관리자에게 문의해주세요."
          ErrorCodeTable={{
            PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          }}
        />
      </Stack>
      <EditDepartmentForm form={form} departmentId={departmentId} />
    </Stack>
  );
}
